import * as React from 'react';

import * as styles from './HighlightingBackground.css';

interface IHighlightingBackgroundProps {
  onClick: (event: React.MouseEvent) => void;
}

export const HighlightingBackground: React.FC<IHighlightingBackgroundProps> = ({ onClick }) => {
  return <div className={styles['container']} onClick={onClick} />;
};
